const { globalSettings } = require('../../helpers/settings');
const { baseBUCGet } = require('../base/baseBUC');

const int = 0;
const decimal = parseFloat(Number('0.00').toFixed(globalSettings?.numberPositions?.decimalPlaces));

const apartmentReceiptModelGet = ({
    buildingId = '',
    apartmentId = '',
    receiptId = '',
    userId = '',
}) => {
    return {
        apartmentId: apartmentId,
        receiptId: receiptId,
        balance: decimal,
        receiptNumber: int,
        receiptNumberApartment: int,
        total: decimal,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};

module.exports = {
    apartmentReceiptModelGet,
};